import React from "react";
import { KpiIcon } from "../../KpiIcons";

const StatCard = ({ iconName, label, value, color, bg, border }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 10,
      padding: "10px 14px",
      background: bg,
      borderRadius: 10,
      border: `1px solid ${border}`,
      minWidth: 105,
      boxSizing: "border-box",
      flexShrink: 0,
    }}
  >
    <div
      style={{
        width: 28,
        height: 28,
        minWidth: 28,
        minHeight: 28,
        maxWidth: 28,
        maxHeight: 28,
        borderRadius: 7,
        background: color + "20",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        overflow: "hidden",
      }}
    >
      <KpiIcon name={iconName} size={14} color={color} />
    </div>
    <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
      <span
        style={{
          fontSize: 9,
          fontWeight: 700,
          color,
          textTransform: "uppercase",
          letterSpacing: ".07em",
          fontFamily: "var(--fm)",
          whiteSpace: "nowrap",
          lineHeight: 1,
          marginBottom: 3,
        }}
      >
        {label}
      </span>
      <span
        style={{
          fontSize: 22,
          fontWeight: 800,
          color: "var(--ink)",
          fontFamily: "var(--fm)",
          lineHeight: 1,
        }}
      >
        {value}
      </span>
    </div>
  </div>
);

export default StatCard;
